export default "__VITE_ASSET__DHiLOER3__"